import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from '@app/lib/services/base-http.service';
import { CaseSheetParams,CaseSheetResponse } from '../models/case-sheet.model';
import { IResponse } from '@app/lib/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class CaseSheetService extends BaseHttpService {
  private baseUrl: string;

    constructor(
        http: HttpClient,
        appConfig: AppConfiguration
    ) {
        super(http, appConfig);
        this.baseUrl = this.appConfig.hostUrl;
    }

    getCaseSheetList(reqBody: CaseSheetParams): Observable<CaseSheetResponse> {
        return this.post<IResponse<any>,any>('appeal-sheet/search.htm', reqBody);
    }


}
